import React,{useState} from 'react';
import {Form,Col,Container,Table,Button,Modal} from 'react-bootstrap';
import questions from './data_moca.json'
import memory_data from './memory.json'
import Popup from './popup'
function AnswerField(props){
   
    const [changed,triggerChange] = useState(props.data!=null?true:false)
    const [previous,setPrevious] = useState(props.data!=null?props.data:0)
    const [val,setVal] = useState(props.data!=null?props.data:"")
   
    const onChange =  (e) =>{
       setVal(e.target.value)
       if (changed){
            props.score(-previous)
            props.score(parseInt(e.target.value))
            setPrevious(parseInt(e.target.value))

       }
       else{
      
            
            setPrevious(parseInt(e.target.value))
            triggerChange(true)
            props.score(parseInt(e.target.value))
            
        }
        props.handler(e)
        setVal(e.target.value)

    }
   
    return(
        <Form.Group as={Col}>
            <Form.Control as={'select'} onChange={onChange} name={props.name} value={val} disabled={props.disabled}>
                {props.scores.map((o,i) =>(
                    <option key={i}>{o}</option>
                ))}
            </Form.Control>
        </Form.Group>
    )
}
AnswerField.defaultProps ={
    data:null
}

function FormTable(props){
    const popupDialog = React.createRef();
    const [show,setShow] = useState(false)
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)
    
    
    const handleModal = (event) =>{
        if (event.target.checked){
            event.target.value = 'True'
        }
        else{
            event.target.value = 'False'
        }
        props.handler(event)
    }
    
    return(
        <>
            <Table responsive={true}>
                <thead> 
                    <tr>
                        <th>Part</th>
                        <th>Score</th>
                    </tr>            
                </thead>
                <tbody>
                    {props.parts.map((p,index) =>(
                        <tr>
                            <td>{index+1}.{p.type}</td>
                            <td width={200}>{p.type!="Memory" ?<AnswerField disabled={props.disabled} handler={props.handler} name={p.name} data={props.data!=null?props.data[p.name]:null}scores={p.scores} score={props.score}/>:<Button variant="outline-primary"  onClick={handleShow} block>Select</Button>} </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            
        <Popup disabled={props.disabled} show={show} data={props.data!=null?props.data:null}handleClose={handleClose} handlePopup={props.handlePopup}/>
        </>
        
    )
}
FormTable.defaultProps = {
    data:null
}
class Moca extends React.Component {
    constructor(props) {
        super(props)
        this.state = {score:0}
        this.handlePopup = this.handlePopup.bind(this)
    }
   
    Scoring = async (val)=> {
       
        
       if (!isNaN(val)){
            await this.setState((prevState) => 
                        ({
                            ...prevState,
                            score:prevState.score + (val)

                        })
                        
            )
        }
        
    }
    onChange = async (event) =>{
        var {name,value} = event.target
        
       
            await this.setState((prevState)=>({
                ...prevState,
                [name]:value,
                
            }))
    
        //this.props.handler('moca',this.state)
        this.props.handler('moca',this.state )
       
    }
    componentDidMount(){
        if (this.props.data!= null){
            this.setState(this.props.data)
        }
    }
    async handlePopup(state){
        const data = state['data']
       await this.setState(data)
       this.props.handler('moca',this.state )
    }
    // componentDidUpdate(prevProps,prevState){
    //     if (prevState != this.state){
    //         this.props.handler('moca',this.state )
           
    //     }
    // }
    render() {
       
        return (
            <Container>
                <h3 style={{textAlign: 'center'}}>Montreal Cognitive Assessment</h3>
                <FormTable parts ={questions} data={this.props.data}handler={this.onChange} score={this.Scoring} disabled={this.props.disabled} handlePopup={this.handlePopup}/>
                <Table>
                    <thead>
                        <tr>
                            <th>Score:</th>
                            <th width={100}>{this.state.score}/30</th>
                        </tr>
                    </thead>
                </Table>
            </Container>
        )
    }
}

export default Moca;

Moca.defaultProps = {
    data:null,
    disabled:false,
}